/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_Lead_ConvertedInputs */

const cs_enum_lead_converted = /** @type {(inputs: Enum_Lead_ConvertedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lead zkonvertován`)
};

const en_enum_lead_converted = /** @type {(inputs: Enum_Lead_ConvertedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lead converted`)
};

/**
* | output |
* | --- |
* | "Lead converted" |
*
* @param {Enum_Lead_ConvertedInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_lead_converted = /** @type {((inputs?: Enum_Lead_ConvertedInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_Lead_ConvertedInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_lead_converted(inputs)
	return cs_enum_lead_converted(inputs)
});